// DOM-free so unit tests can import it.
/** Short age of a line: now, 5m, 3h, then the clock time (FR-CHAT-03). */
export function shortAge(at: number, nowMs: number): string {
  if (!at) return '';
  const mins = Math.floor((nowMs - at) / 60_000);
  if (mins < 1) return 'now';
  if (mins < 60) return `${mins}m`;
  if (mins < 12 * 60) return `${Math.floor(mins / 60)}h`;
  const d = new Date(at);
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}
